import RiveComponent, { RiveAlignment } from '../../RiveComponent'
import RenderHTML from '../../ui-components/RenderHTML'
import { PrimaryButton } from '../PrimaryButton'
import { SecondaryButton } from '../SecondaryButton'
import { getBottomPadding } from '../../../utils/sessionStorage'
import { TerminalStatusContext } from '../../../types/mf-execution.types'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { useEffect } from 'react'

export const Pending = ({
  title,
  caption,
  ctas,
  statusContext
}: {
  title: string
  caption?: string
  ctas: { ctaType: 'primary' | 'secondary'; label: string; onClick: () => void }[]
  statusContext?: TerminalStatusContext
}) => {
  const getScreenName = () => {
    switch (statusContext) {
      case TerminalStatusContext.AUTO_PAY:
        return 'Autopay_setup_pending'
      default:
        return 'Payment pending'
    }
  }

  useEffect(() => {
    trackEvent({
      eventName: EventNames.ScreenLoaded,
      payload: {
        ScreenName: getScreenName()
      }
    })
  }, [])
  return (
    <div
      style={{ paddingBottom: `calc(${getBottomPadding()}px + 8px)` }}
      className='flex flex-col h-full w-full relative bg-white px-5 pt-[35vh]'
    >
      {/* Animated Checkmark */}
      <div className='flex mt-3 h-12 w-12 mt-12'>
        <RiveComponent
          src={`/rives/mf-execution/error.riv`}
          alignment={RiveAlignment.CENTER_LEFT}
          fallback={<PendingFallback />}
        />
      </div>
      {/* Text */}
      <div className='text-[28px] font-[500] mt-4 text-[#232323] leading-[150%] text-left animate-fade-150'>
        <RenderHTML innerHTMLText={title} />
      </div>

      {caption && (
        <div className='text-[14px] font-[400] text-[#6A6E6E] leading-[160%] text-left mt-3 animate-fade-150'>
          <RenderHTML innerHTMLText={caption} />
        </div>
      )}

      <div
        style={{ bottom: `${getBottomPadding() + 8}px` }}
        className='flex gap-4 w-full justify-center items-end absolute bottom-0 left-0 px-5 z-10'
      >
        {ctas.map((cta) =>
          cta.ctaType === 'primary' ? (
            <PrimaryButton
              key={cta.label}
              onClick={cta.onClick}
              label={cta.label}
              primaryButtonClassName='!h-[56px] !text-[16px] !font-[500]'
            />
          ) : (
            <SecondaryButton
              key={cta.label}
              onClick={cta.onClick}
              label={cta.label}
              secondaryButtonClassName='!h-[56px] !text-[16px] !font-[500]'
            />
          )
        )}
      </div>
    </div>
  )
}

export const PendingFallback = () => {
  return (
    <div className='flex justify-start h-max w-full mt-auto'>
      <PendingIcon />
    </div>
  )
}

export const PendingIcon = () => {
  return (
    <RenderHTML
      innerHTMLText={`<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 15V24H28" stroke="#F29A32" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="20" cy="24" r="18.5" stroke="#F29A32" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`}
    />
  )
}
